import React, { lazy } from 'react';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../ui/Button';
import { PriceDisplay } from '../ui/PriceDisplay';
export function Guarantee() {
  return <section className="py-10 px-4 bg-white" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <div className="bg-gradient-to-br from-cream to-gold-light/30 border-4 border-gold rounded-3xl p-6 md:p-8 text-center relative shadow-2xl mt-8" data-id="element-103">
          <div className="absolute -top-12 left-1/2 -translate-x-1/2 bg-white rounded-full p-4 shadow-xl border-4 border-gold" data-id="element-104">
            <ShieldAlert className="w-14 h-14 text-gold" data-id="element-105" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-forest-green mt-6 mb-4 font-serif leading-tight" data-id="element-106">
            🛡️ Mi Garantía Personal de 30 Días: "AMALO O DEVOLVELO"
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-gray-800 leading-relaxed text-left font-medium" data-id="element-107">
            <p data-id="element-108">
              Odio la palabra "garantía" usada como truco de marketing. Así que
              voy a ser directo:
            </p>
            <div className="bg-white p-5 md:p-6 rounded-2xl border-l-8 border-gold shadow-md" data-id="element-109">
              <p className="font-black text-forest-green text-xl md:text-2xl leading-relaxed" data-id="element-110">
                Si en 30 días no ves una mejora visible en tu mascota — más
                energía, mejor digestión, pelaje más brillante — te devuelvo el
                100% de tu dinero sin preguntas, sin letra chica, sin dramas.
              </p>
            </div>
            <p data-id="element-111">Eso es lo que significa confiar de verdad en lo que vendés.</p>
            <div className="bg-forest-green text-gold py-3 px-5 rounded-xl mt-4 shadow-inner" data-id="element-112">
              <p className="font-black text-center text-2xl md:text-3xl uppercase tracking-widest font-serif" data-id="element-113">
                Garantía de hierro. 30 días. Sin excusas.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center space-y-4 max-w-2xl mx-auto" data-id="element-114">
          <div className="space-y-3 text-lg md:text-xl text-gray-800 leading-relaxed font-medium mt-6" data-id="element-115">
            <div className="p-2 bg-white rounded-3xl shadow-lg border border-gray-100 mb-4 max-w-md mx-auto" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/dcjcJJT1LrshM2uPy9QzTc/20260318_0852_Serene_Pet_Companionship_simple_compose_01km0ckva8eg2am242y5yhj4z3_(1)_(1).webp" alt="Dueña feliz con su perro sano" className="rounded-2xl w-full object-cover aspect-[4/3]" loading="lazy" decoding="async" width={400} height={300} data-id="element-117" />
            </div>
            <p className="font-black text-3xl md:text-4xl text-forest-green font-serif" data-id="element-118">
              Tenés una decisión que tomar. Y creo que es fácil.
            </p>
            <p data-id="element-119">
              Por menos de lo que gastás en una semana de alimento comercial,
              podés darle a tu peludo una vida completamente diferente. Más
              feliz. Más sana. Más larga.
            </p>
            <p data-id="element-120">
              Imaginá ver a tu perro correr como cachorro de nuevo. Ver a tu
              gato ronronear de satisfacción después de cada comida. Saber con
              certeza absoluta que estás haciendo lo mejor por quien más querés.
            </p>
            <div className="bg-cream p-4 rounded-2xl border-2 border-gold/30 mt-4" data-id="element-121">
              <p className="text-3xl md:text-4xl font-black text-forest-green font-serif" data-id="element-122">
                Eso vale mucho más que{' '}
                <span className="text-gold drop-shadow-sm" data-id="element-123">
                  <PriceDisplay type="offer" showCurrencyCode data-id="element-124" />
                </span>
                .
              </p>
            </div>
          </div>

          <div className="pt-4" data-id="element-125">
            <Button fullWidth className="md:w-auto shadow-glow-lg" data-id="element-126">
              ▶ ACCEDER A ALIMENTA CON AMOR AHORA →
            </Button>
            <p className="mt-3 text-base text-gray-600 font-black tracking-wide" data-id="element-127">
              Acceso instantáneo · Sin envíos · Empezás hoy mismo
            </p>
          </div>
        </div>
      </div>
    </section>;
}